import { useAppState } from '@sky-distribution/gp-onboarding-app-state-service';
import { FC, PropsWithChildren } from 'react';

export interface XRouteProps {
  element: React.ReactElement;
  path: string;
}

export const XRoute: FC<PropsWithChildren<XRouteProps>> = ({
  element,
  path,
}) => {
  const { context } = useAppState();

  return path === context.route ? element : null;
};
